module.exports = __webpack_public_path__ + "assets/8.jpg?bddd1c771c954af4277ee0d8b6bef6e3";